import { SurveyQuestion } from '@/types/Psychosocial';

interface QuestionGroups {
	workloadQuestions: SurveyQuestion[];
	radioQuestions: SurveyQuestion[];
	sliderQuestions: SurveyQuestion[];
}

export function filterQuestionsByType(questions?: SurveyQuestion[]): QuestionGroups {
	if (!questions) {
		return {
			workloadQuestions: [],
			radioQuestions: [],
			sliderQuestions: []
		};
	}

	const workloadQuestions = questions.filter((q) => q.category === 'workload') || [];

	const radioQuestions =
		questions.filter((q) => q.category !== 'workload' && q.options && q.options.length > 0) || [];

	const sliderQuestions =
		questions.filter((q) => q.category !== 'workload' && (!q.options || q.options.length === 0)) || [];

	return {
		workloadQuestions,
		radioQuestions,
		sliderQuestions
	};
}
